/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountListResponseDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountListResponseDto';
import type { Wealthlane_CustomerService_Dtos_TransferAgent_ParticipantTransferAgentAccountListResponseDto } from '../models/Wealthlane_CustomerService_Dtos_TransferAgent_ParticipantTransferAgentAccountListResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantAccountsService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountListResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantAccountsParticipantBrokerAccounts(): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-accounts/participant-broker-accounts',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_TransferAgent_ParticipantTransferAgentAccountListResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantAccountsParticipantTransferAgentAccounts(): CancelablePromise<Wealthlane_CustomerService_Dtos_TransferAgent_ParticipantTransferAgentAccountListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-accounts/participant-transfer-agent-accounts',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
